import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";

export const FeedOverviewContext = createContext(null);

type Props = {
  children: ReactElement;
};

const FeedOverviewProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["feed_overview"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/overview?checkType=feed`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <FeedOverviewContext.Provider value={contextValue}>
      {children}
    </FeedOverviewContext.Provider>
  );
};

export default FeedOverviewProvider;
